import(/* webpackMode: "eager" */ "/home/interim/frontend/app/services/recruitment/page.tsx");
